export default __webpack_public_path__ + "static/media/big-theme.6b3fe0cd.png";